import Axios from "../../../services/apiFootballService/connection";
import logger from "../../../utils/logger";
import useCountryStore from "../../../store/appData/country";

export const startUpdateCountry = async () => {
  const countries = JSON.parse(localStorage.getItem("countries"));

  if (!countries || countries.expiry < Date.now()) {
    Axios.get("/countries")
      .then((response) => {
        let countries = {};
        countries.expiry = Date.now() + 86400000 * 365;
        countries.data = response.data.response;
        useCountryStore.getState().setCountry(countries.data);
        localStorage.setItem("countries", JSON.stringify(countries));
      })
      .catch((err) => {
        logger.error(err);
      });
  } else {
    useCountryStore.getState().setCountry(countries.data);
  }
};
